export default __webpack_public_path__ + "media/images/elements/09-8975f224ed2480696b8c7069207f7b6b.png";